module.exports = __webpack_public_path__ + "img/defaultuser.47ef784a.svg";